import React from "react";

export default ({ value = 0 }) => {
  let tableValue = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(value);
  if (tableValue === "0") {
    tableValue = "N/A";
  }
  return (
    <div>
      <span>{tableValue}</span>
    </div>
  );
};
